export default __webpack_public_path__ + "static/media/divinevigor.ad41b513.png";